import {Promise} from "axios";
import mdAxios from "../../core/common/config/axios-config";
import {Criterion} from "../domain/criterion/criterionDomain";
import {observable} from "mobx";
import {CriterionScore} from "../domain/criterion/criterionScoreDomain";
import {SubCriterion} from "../domain/criterion/subCriterionDomain";
import {SubCriterionParameterValue} from "../domain/criterion/subCriterionParameterValueDomain";


class CriterionService {
  @observable public criterionObject: Criterion;
  @observable public subCriterionObject: SubCriterion;


  readCriteria(): Promise<Criterion[]> {
    return mdAxios.get('sbtool/criteria')
      .then(response => response.data.map(d => new Criterion(d)));
  }

  readCriterion(criterionId: number): Promise<Criterion> {
    return mdAxios.get('sbtool/criteria/' + criterionId)
      .then(response => new Criterion(response.data));
  }

  readSubCriterion(criterionId: number): Promise<SubCriterion> {
    return mdAxios.get('sbtool/criteria/sub-criteria/' + criterionId)
      .then(response => new SubCriterion(response.data));
  }

  readCriterionScore(scoreId: number): Promise<CriterionScore> {
    return mdAxios.get('sbtool/criteria-score/' + scoreId)
      .then(response => new CriterionScore(response.data));
  }

  readSubCriterionParamValue(scoreId: number): Promise<SubCriterionParameterValue> {
    return mdAxios.get('sbtool/sub-criterion/params/' + scoreId)
      .then(response => new SubCriterionParameterValue(response.data));
  }
}

export default new CriterionService();



// WEBPACK FOOTER //
// ./src/sbtool/service/criterionService.ts